import { Helpers } from '@shared/utils/Helpers';

const getUTMSource = (utm_source?: string): string => {
  const utmSources: Record<string, string> = {
    facebook:
      'https://pv2n.adj.st/subscription?vip_journey=vip-journey-mode&adj_t=x1m4fex_eu4v35a&adj_deep_link=meaapp.app.link%3A%2F%2Fsubscription%3Fvip_journey%3Dvip-journey-mode',
    google:
      'https://pv2n.adj.st/subscription?vip_journey=vip-journey-mode&adj_t=piw5o1q_o81hbno&adj_deep_link=meaapp.app.link%3A%2F%2Fsubscription%3Fvip_journey%3Dvip-journey-mode',
    snapchat:
      'https://pv2n.adj.st/subscription?vip_journey=vip-journey-mode&adj_t=xkk7l8h_nvqf5ft&adj_deep_link=meaapp.app.link%3A%2F%2Fsubscription%3Fvip_journey%3Dvip-journey-mode',
  };

  return utm_source && utmSources[utm_source] ? utmSources[utm_source] : utmSources.google;
};

export const useUTMSource = (): string => {
  return getUTMSource(Helpers.getUrlParameter('utm_source'));
};
